import * as React from 'react';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import PixIcon from '@mui/icons-material/Pix';
import { CardForm } from './CardForm';
import { Button, Typography } from '@mui/material';
import { AppContext } from "../context";
import { useHistory } from "react-router-dom";
import { useContext } from "react";

export default function NavigationMenu() {
  const {bankslipPayment, lead, acceptablePaymentMethods} = useContext<any>(AppContext)
  const [value, setValue] = React.useState(0);
  const handle = (value: any) => {
    setValue(value)
  }
  const history = useHistory();

  const bankslipPay = async () => {
    const payment = await bankslipPayment()
    if (payment) {
      history.push(`/pendente/${lead.leadId}`)
    } else if (!payment) {
      history.push('/falha')
    }
  }
  return (
      <>
    <Box sx={{ width: '100%' }}>
      <BottomNavigation
        sx={{backgroundColor: "background.default", justifyContent: 'space-evenly'}}
        showLabels
        value={value}
        onChange={(event, newValue) => {
            handle(newValue);
        }}
      >
        {acceptablePaymentMethods.credicard && (
           <BottomNavigationAction label="Cartão de Crédito" icon={<CreditCardIcon />} />
        )}
        {acceptablePaymentMethods.bankslip && (
           <BottomNavigationAction label="Boleto" icon={<DocumentScannerIcon />} />
          )}
        {acceptablePaymentMethods.pix && (
           <BottomNavigationAction label="Pix" icon={<PixIcon />} />
        )}
       
       
       
      </BottomNavigation>
    </Box>
        {value === 0 && (
          <Box sx={{margin: 'auto'}}>
            <CardForm />
          </Box> )}
          {value === 1 && (
          <Box sx={{
            height: '100%',
            width: '100%',
            mt: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between'
            }}>
            <Typography
            sx={{
              color: '#656565', 
              fontSize: '1.2rem',
              textAlign: 'center'
            }}>
            Clique em prosseguir para gerar seu boleto!
          </Typography>
            <Button sx={{ my: 2, width: 150}}
            variant="contained" 
            color='primary'
            type="button"
            onClick={bankslipPay}>
              Prosseguir
            </Button>
          </Box> )}
    </>
  );
}